import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
import { PuffLoader } from 'react-spinners';

import { checkPreviousAction } from 'actions/workflow';

const Redirection = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const key = searchParams.get('key');
  
    if (!key) {
      navigate('/');
    } else {
      dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/fsl/redirection/token/${token}`,
        success: (res) => {
          navigate(get(res, 'data.url'));
        },
        fail: (error) => {
          navigate(`/applications/${params.workflowtype}/error?key=${key}`, {
            state: { message: get(error, 'data.message', 'Internal server error') },
          });
        },
      }));
    }
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 500 }}>
      <PuffLoader color="#3989E3" size={100} />
    </div>
  );
};

export default Redirection;
